function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function CircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 14 14",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.4279 10.4294C9.51835 11.3389 8.28474 11.8499 6.99844 11.8499C5.71214 11.8499 4.47852 11.3389 3.56897 10.4294C2.65942 9.51982 2.14844 8.2862 2.14844 6.9999C2.14844 5.7136 2.65942 4.47999 3.56897 3.57043C4.47852 2.66088 5.71214 2.1499 6.99844 2.1499C8.28474 2.1499 9.51835 2.66088 10.4279 3.57043C11.3375 4.47999 11.8484 5.7136 11.8484 6.9999C11.8484 8.2862 11.3375 9.51982 10.4279 10.4294Z",
    strokeWidth: "1.5"
  }));
}
export default CircleIcon;
//# sourceMappingURL=Circle.js.map